export default __webpack_public_path__ + "static/media/785.3d545ac5.png";